import React, { Component } from 'react';

import '../../../css/ResetFilter.css';

class ResetFilter extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      value: props.value,
      all: props.all
    }

    this.onClickCb = props.onClick;

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      value: newProps.value,
      all: newProps.all
    });
    this.onClickCb = newProps.onClick;
  }


  render() {

    return (

      <li className={`clickable ${this.props.all ? 'all' : ''}`} onClick={this.onClickCb}>
        <span>{this.state.value}</span>
        <span className="close">x</span>
      </li>

    );

  }

}

export default ResetFilter;



// WEBPACK FOOTER //
// ./src/js/components/filter/ResetFilter.jsx